// import VueFab from './vue-fab'
const VueFab = r => require.ensure([], () => r(require('./vue-fab.vue')), 'components-chunk')

export { VueFab }
